/**
 * @ngdoc service
 * @module flowingly.services
 * @name flowinglyCaseConversionInterceptor
 *
 * @description
 * Global HTTP response interceptor that converts all successful API response
 * bodies to camelCase. This lets the rest of the app treat responses as
 * uniformly camelCase, regardless of whether the backend endpoint applied the
 * [CamelCaseAction] attribute.
 *
 * Only successful responses are transformed. Error responses are left untouched
 * because their bodies (e.g. modelState validation errors) can be keyed by
 * dynamic field paths that must not be re-cased.
 *
 * All successful response bodies are normalised to camelCase, including custom
 * database responses. Backend APIs must therefore expose dynamic record keys
 * using the same camelCase contract as fixed DTO properties.
 */
import { IHttpInterceptor, IHttpPromiseCallbackArg } from 'angular';
import { toCamelCaseDeep } from './case-converter';

angular
  .module('flowingly.services')
  .factory(
    'flowinglyCaseConversionInterceptor',
    flowinglyCaseConversionInterceptor
  );

function flowinglyCaseConversionInterceptor(): IHttpInterceptor {
  //API
  const service = {
    response: response
  };

  return service;

  //////////// Public API Methods

  function response<T>(response: IHttpPromiseCallbackArg<T>) {
    const data = response.data;
    if (isConvertibleData(data)) {
      response.data = toCamelCaseDeep(data);
    }

    return response;
  }

  function isConvertibleData(data: unknown) {
    if (data === null || typeof data !== 'object') {
      return false;
    }
    return true;
  }
}
